<template>
  <iframe
    id="pdf-js-viewer"
    title="webviewer"
    height="100%"
    width="100%"
    frameborder="0"
    :src="path + url"
  ></iframe>
</template>

<script>
export default {
  name: 'PDFJSViewer',
  props: ['url'],
  data() {
    return {
      path: '/lib/pdfjs/web/viewer.html?file=', //path of the PDF.js viewer.html
    }
  },
}
</script>
<style scoped>
div {
  width: 100%;
  height: 100%;
  min-width: 400px;
}
</style>
